import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Send HttpOnly cookies with every request — the backend translates them
// into Authorization headers via middleware, so explicit Bearer headers
// are not needed.
axios.defaults.withCredentials = true;

// Browser's IANA timezone on every request so the backend can stamp
// generated PDFs with the user's local time (instead of server UTC /
// hardcoded GMT+4). Backend middleware reads X-User-Timezone and parks
// it in a contextvar; user_timestamp.format_user_local_timestamp() reads
// from there. Invalid/missing falls back to Indian/Mauritius.
axios.interceptors.request.use((config) => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz) config.headers["X-User-Timezone"] = tz;
  } catch {
    // Intl unavailable (very old browsers / SSR) — backend default kicks in.
  }
  return config;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
